import { COLORS } from '@shared/config/colors/colors';
import { styled } from 'goober';

export const FinderWrapper = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    padding: 16px 20px;
    border: 1px solid ${COLORS.neutral_05};
    border-radius: 20px;
    background-color: ${COLORS.neutral_00};
`;

export const FinderInfo = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FeedbackRequestCount = styled('div')`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    padding: 0 7px;
    border-radius: 10px;
    background-color: ${COLORS.neutral_10};
`;

export const FinderSearchWrapper = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
`;
